import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { NavContext } from "#nav-context";

/** Whether a nested app surface has temporarily suppressed the outer navigation header fade. */
export function useIsPrimaryControlsStripFadeHidden() {
  const [isPrimaryControlsStripFadeHidden] = useContextSelectors(
    NavContext,
    (context) => context.isPrimaryControlsStripFadeHidden,
  );
  return isPrimaryControlsStripFadeHidden;
}

/** Setter for {@link useIsPrimaryControlsStripFadeHidden}. */
export function useSetIsPrimaryControlsStripFadeHidden() {
  const [setIsPrimaryControlsStripFadeHidden] = useContextSelectors(
    NavContext,
    (context) => context.setIsPrimaryControlsStripFadeHidden,
  );
  return setIsPrimaryControlsStripFadeHidden;
}
